<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł menu bocznego',
              modelPath: [this, 'form', 'sided_menu_title'],
              multilingual: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: get(item, ['numeration']),
                  fields: [
                    new fields.Input({
                      label: 'Numeracja',
                      modelPath: [this, 'form', 'items', i, 'numeration'],
                      required: true
                    }),
                    new fields.Input({
                      label: 'Tekst',
                      type: 'textarea',
                      modelPath: [this, 'form', 'items', i, 'text'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
